import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject

export class Portefeuille {
  constructor (
    codeContact?: string,
    nom?: string,
    email?: string,
    numTel?:string
  ) {
    this.codeContact = codeContact as any;
    this.nom = nom as any;
    this.email = email as any;
    this.numTel = numTel as any;
  }

    @JsonProperty(String)
    @Optional
    codeContact?:string;

    @JsonProperty(String)
    @Optional
    nom?:string;

    @JsonProperty(String)
    @Optional
    email?:string;

    @JsonProperty(String)
    @Optional
    numTel?:string;
}
